import { NodeStateStatus, NodeType, SessionStatus } from '@lemonade-hq/chat-engine';
import type { RenderNodeState, Step } from '@lemonade-hq/chat-engine';
import { getRandomId } from '@lemonade-hq/ts-helpers';
import type { ChatEngineSession } from './chat_engine.client';
import type { WizardExtendedStepWithPersistence } from './wizard_persistence.context';

export function createLocalSessionFromStep<TPresentation = undefined, TDataExtension = unknown>(
  scriptName: string,
  step: WizardExtendedStepWithPersistence<Step<TPresentation, TDataExtension>>,
): ChatEngineSession<TPresentation> {
  return {
    schema: {},
    assets: [],
    auth: {},
    script: {
      name: scriptName,
      version: '1',
      engineVersion: 'local',
      id: 'local-script',
    },
    sessionId: 'local-session',
    sessionStatus: SessionStatus.Pending,
    history: [wrapStepInRenderNode(scriptName, step)],
  };
}

export function wrapStepInRenderNode<TPresentation = undefined, TDataExtension = unknown>(
  scriptName: string,
  step: WizardExtendedStepWithPersistence<Step<TPresentation, TDataExtension>>,
): RenderNodeState<TPresentation, TDataExtension> {
  return {
    id: `${scriptName}-${step.name}-${getRandomId()}`,
    name: step.name,
    renderedStep: step,
    status: NodeStateStatus.Pending,
    type: NodeType.Render,
  };
}
